import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = import.meta.env.VITE_APP_API;

export const coursePaymentsApi = createApi({
  reducerPath: "coursePaymentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,
  }),
  endpoints: (builder) => ({
    getCoursePayments: builder.query({
      query: ({ search = "", ordering = "", status = "", start_date = "", end_date = "", page = 1 } = {}) =>
        `/api/course/admin/course_payments?search=${search}&ordering=${ordering}&status=${status}&start_date=${start_date}&end_date=${end_date}&page=${page}`,
    }),
    enrollCourseByAdmin: builder.mutation({
      query: (body) => {
        const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
        return {
          url: "/api/course/course_enroll_by_admin",
          method: "POST",
          body,
          headers: access_token ? { Authorization: `Bearer ${access_token}` } : {},
        };
      },
    }),
    enrollCourseByCsv: builder.mutation({
      query: (body) => {
        const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
        return {
          url: "/api/course/course_enroll_by_csv",
          method: "POST",
          body,
          headers: access_token ? { Authorization: `Bearer ${access_token}` } : {},
        };
      },
    }),
    enrollCourseWithAccessByCsv: builder.mutation({
      query: (body) => {
        const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
        return {
          url: "/api/course/course_access_by_csv/",
          method: "POST",
          body,
          headers: access_token ? { Authorization: `Bearer ${access_token}` } : {},
        };
      },
    }),
  }),

});

export const { 
  useGetCoursePaymentsQuery, 
  useEnrollCourseByAdminMutation, 
  useEnrollCourseByCsvMutation ,
  useEnrollCourseWithAccessByCsvMutation
} = coursePaymentsApi;
